import * as ConfigJson from '../../config.js';
import { default as UtilsCustomer } from './utils.Customer.js';
import { default as UtilsLocalization } from './utils.Localization.js';
import { default as UtilsLanguage } from './utils.Language.js';
import { default as UtilsLogger } from './utils.Logger.js';
import { default as UtilsClasses } from './utils.Classes.js';
//import { default as UtilsCookie } from './utils.Cookie.js';
import { default as UtilsSpinner } from './utils.Spinner.js';
import { default as UtilsMetadata } from './utils.Metadata.js';
import { default as UtilsMap } from './utils.Map.js';
import { default as UtilsFormatter } from './utils.Formatter.js';
import { default as UtilsDevices } from'./utils.Devices.js';
import Cookie from 'js-cookie';
import UtilsCaching from './utils.Caching.js';
import UtilsData from './utils.Data.js';

export default class Utils {
  static get Configuration() {
    let current = ConfigJson.default.find(brand => brand.host === "default");

    if (ConfigJson.default.find(brand => window.location.host.indexOf(brand.host) !== -1))
      current = ConfigJson.default.find(brand => window.location.host.indexOf(brand.host) !== -1);

    return current.params;
  }
  static get Customer() { return UtilsCustomer; }
  static get Localization() { return UtilsLocalization; }
  static get Language() { return UtilsLanguage; }
  static get Logger() { return UtilsLogger; }
  static get Classes() { return UtilsClasses; }
  static get Cookie() { return Cookie; }
  static get Spinner() { return UtilsSpinner; }
  static get Metadata() { return UtilsMetadata; }
  static get Map() { return UtilsMap; }
  static get Formatter() { return UtilsFormatter; }
  static get Devices() { return UtilsDevices; }
  static get Caching() {return UtilsCaching; }
  static get Data() {return UtilsData; }
}
